import { ElementColors } from "@/common/theme/ElementColors";
import { PPStatusData } from "@/picking-portal/models/PPStatusData";

export enum PPClickAndCollectStatus {
  SUBMITTED = "SUBMITTED",
  PICKED = "PICKED",
  COLLECTED = "COLLECTED",
  CANCELLED = "CANCELLED",
}

const prefix = "modules.packing-portal.click-and-collect.status.";

export const PPClickAndCollectStatusMap: Map<PPClickAndCollectStatus, PPStatusData> = new Map<
  PPClickAndCollectStatus,
  PPStatusData
>([
  [PPClickAndCollectStatus.SUBMITTED, { text: `${prefix}submitted`, color: ElementColors.Chip.Submitted }],
  [PPClickAndCollectStatus.PICKED, { text: `${prefix}picked`, color: ElementColors.Chip.Picked }],
  [PPClickAndCollectStatus.COLLECTED, { text: `${prefix}collected`, color: ElementColors.Chip.Collected }],
  [PPClickAndCollectStatus.CANCELLED, { text: `${prefix}cancelled`, color: ElementColors.Chip.Cancelled }],
]);
